import {MatPaginatorIntl} from '@angular/material';

export class CzechPaginatorIntl extends MatPaginatorIntl {
    itemsPerPageLabel = 'Položek na stránku';
    nextPageLabel     = 'další';
    previousPageLabel = 'předchozí';

    getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            return `0 (celkem ${length})`;
        }
        length = Math.max(length, 0);
        const /** @type {?} */ startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const /** @type {?} */ endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} (celkem ${length})`;
    };
}


// WEBPACK FOOTER //
// /app/src/model/Providers/CzechPaginatorIntl.ts